module.exports = __webpack_public_path__ + "img/title4.b22b2873.png";